export enum AdminStatus {
  INCOMPLETE = 'Incomplete',
}
